import { render, staticRenderFns } from "./ImageLibrarySidebar.vue?vue&type=template&id=2248e8c6&scoped=true&"
import script from "./ImageLibrarySidebar.vue?vue&type=script&lang=js&"
export * from "./ImageLibrarySidebar.vue?vue&type=script&lang=js&"
import style0 from "./ImageLibrarySidebar.vue?vue&type=style&index=0&id=2248e8c6&lang=scss&scoped=true&"
import style1 from "./ImageLibrarySidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2248e8c6",
  null
  
)

export default component.exports